/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Box, TextField, Typography, Tab, Tabs, Tooltip, Button, Skeleton, CircularProgress, Alert } from '@mui/material';
import DisplayContent from '../../shared/DisplayContent';
import {
  LuiCard,
  LuiMaterialTable,
  LuiPageHeader,
  LuiEditor,
  LuiObjectTag
} from '@jda/lui-common-component-library-mui5';
import Copy from '@jda/lui-common-icon-library-mui5/ui/Copy';
import CopyToClipboard from 'react-copy-to-clipboard';
import { setCurrentMachineName, setCurrentMachineSelection } from '../../store/machine/machineActionCreator';
import { hideSnackbar, setSnackBarMessage } from '../../store/snackBar/snackBarActionCreator';
import { getFeatureFlag as useFeatureFlag } from '@jda/lui-portal-utilities';
import {
  AUTOCOMPLETE_PLACEHOLDER,
  MACHINE_NAME_LABEL,
  SUBJECT_ID,
  CLIENT_ID,
  CLIENT_SECRET_TITLE,
  CLIENT_SECRET_SUBTITLE,
  MACHINE_NAME,
  EDITOR,
  EDITOR_TOPICS,
  COMMAND_COPIED_TO_CLIPBOARD,
  SNACKBAR_ALERT_DEFAULT_PROPS,
  TENANT_NAME,
  B2C_DOMAIN,
  COPY_IDS,
  MACHINE_TYPE_SNOWFLAKE_CAPITAL,
  MACHINE_TYPE_SNOWFLAKE_LOWER,
  MACHINE_CATEGORY_TYPE,
  MACHINE_TYPE,
  LABELS,
  secretTypeOptions
} from './constants';
import { UBER, MACHINE_TYPES, UBER_REALM_CLIENT_TOOLTIP } from '../MachineList/Constants';
import { getAllowedRealms, getClientById, rotateClientSecret, updateClient } from '../../services/client';
import { useStyles } from './styles';
import RoleAssignments from '../../shared/RoleAssignments';
import { ISecret, IUberRealm } from '../../models/Machines/ClientContracts';
import SecretDetails from './SecretDetails';
import { checkPermission } from '../../shared/CheckPermissions/CheckPermission';
import { permissions } from '../../shared/CheckPermissions/constants';
import { selectAllAssignedPermissions } from '../../store/auth/authSelector';
import { selectMachineCurrentName } from '../../store/machine/machineSelector';
import { useSelector } from 'react-redux';
import AddSecretBox from './AddSecret';
import ApiSubscriptions from './ApiSubscriptions';
import { getUserTokenRealmId, isPortalV2, getUserTokenData } from '../../utility/commonUtility';
import { getPortalHost } from '@jda/lui-portal-utilities';
import { selectRealmInfo } from '../../store/realmSettings/realmSettingsSelector';
import { useHistory, useParams } from 'react-router-dom';
import { ERROR_MACHINE_NOT_FOUND } from '../../container/AddSubscriptions/constants';
import { SUBJECT_ID_COPIED_TO_CLIPBOARD } from '../../container/Users/constants';
import {
  BUTTON_CLOSE,
  CLIENT_ID_COPIED_TO_CLIPBOARD,
  ROTATE_CLIENT_SECRET_FAILURE,
  ROTATE_CLIENT_SECRET_SUCCESS,
  ROTATE_SECRET,
  ROTATE_SECRET_TITLE
} from '../../container/Machines/constants';
import interpolateString from '../../utility/stringInterpolation';
import { DIALOGUE_CANCEL, ROTATE_SECRET_CONTENT } from '../MachineList/Constants';
import { AlertDialog } from '../../shared/Dialog/AlertDialog';
import { setSelectedTab } from '../../store/appLoader/appLoaderActionCreator';
import SnackbarAlert from '../../shared/SnackbarAlert';
import useWindowDimensions from '../../utility/useWindowDimensions';
import FormDialog from '../../shared/Dialog/FormDialog';
import MachineSecretCopyDialog from '../MachineSecretCopyDialog/MachineSecretCopyDialog';
import TopicSubscription from './TopicSubscription';
import { HARNESS_FEATURE_FLAG } from '../../utility/constants';
import { REALM_TYPE, MIGRATION_STATUS } from '../AddMachineDialog/contants';
import { ArrowRight } from '@jda/lui-common-icon-library-mui5';


const snackBarAlertDefaultProps = {
  show: false,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as 'success' | 'error'
};

const env = window['env'];
const TenantName = env.APP_TENANT_HOST || env.TENANT_HOST || TENANT_NAME;
const B2CDomain = env.APP_B2C_DOMAIN_HOST || env.B2C_DOMAIN_HOST || B2C_DOMAIN;
const DefaultScope = env.DEFAULT_SCOPE;
const scope = DefaultScope?.replace('access', '.default');
const tokenEndpoint = isPortalV2() ? getPortalHost().replace('.portal', '.auth') + `/oauth/token` : `https://{REALMKEY}.auth.{RUNTIME}.{GEO}.{DOMAIN}/oauth/token`;
const runtime = {
  customer : 'live | val | prev | stage',
  rnd:'interop | psr | dev'
};
const geo = 'na | eu | ap | au';
const domain = {
  customer :'blueyonder.inc',
  rnd : 'blueyonder.dev'
};

const MachineDetails = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { height } = useWindowDimensions();
  const { machineId } = useParams<{ machineId: string }>();

  const selectedRealmInfo = useSelector(selectRealmInfo);
  const machineName = useSelector(selectMachineCurrentName);
  const assignedPermissions = useSelector(selectAllAssignedPermissions);

  const [value, setValue] = useState(0);
  const [machine, setMachine] = useState<any>(null);
  const [secretText, updateSecretText] = useState('');
  const [showLoader, showHideLoader] = useState(false);
  // const [editorRefs, setEditorRefs] = useState<any>(null);
  const [showDialogLoader, setDialogHideLoader] = useState(false);
  const [secretCopyDialog, setSecretCopyDialog] = useState(false);
  // const [secretMachineId, setRotateSecretMachineId] = useState('');
  const [machineNameLocal, setMachineNameLocal] = useState('');
  const [isUberRealmChild, setIsUberRealmChild] = useState(Boolean);
  const [allowedRealms, setAllowedRealms] = useState<Array<IUberRealm>>([]);
  const [showSecretConfirmation, setShowSecretConfirmation] = useState(false);
  const [snackbarAlertProps, setSnackbarAlertProps] = useState(snackBarAlertDefaultProps);
  const [isLoading, setIsLoading] = useState(false);
  const [realmKey, setRealmKey] = useState('');
  const portalV2 = isPortalV2();
  const efsFFEnabled = useFeatureFlag(HARNESS_FEATURE_FLAG.efsMachineFF);
  const isSnowflake =
    machine?.type === MACHINE_TYPE_SNOWFLAKE_CAPITAL || machine?.type === MACHINE_TYPE_SNOWFLAKE_LOWER;
  const allowedSecretCount = isSnowflake ? 1 : 2;

  const classicSecrets = machine?.secrets?.filter(secret => secret.type === MIGRATION_STATUS.CLASSIC);
  const modernSecrets = machine?.secrets?.filter(secret => secret.type === MIGRATION_STATUS.MODERN);
  const showClassicSecretsTab = selectedRealmInfo?.migrationState !== MIGRATION_STATUS.MODERN;
  const showModernSecretsTab = [MIGRATION_STATUS.PREPARED, MIGRATION_STATUS.DUAL, MIGRATION_STATUS.MODERN].includes(selectedRealmInfo?.migrationState);

  const TabPanel = useMemo(
    () => (props: any) => {
      const { children, value, index, ...other } = props;
      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          style={{ width: '100%' }}
          id={`vertical-tabpanel-${index}`}
          aria-labelledby={`vertical-tab-${index}`}
          {...other}
        >
          {value === index && <Box sx={{ height: '100%' }}>{children}</Box>}
        </div>
      );
    },
    []
  );

  const getDefaultRealm = (clientId: string) => {
    if (clientId !== '') {
      getAllowedRealms(clientId).then(async (response: any) => {
        const userRealmId = await getUserTokenRealmId();
        const res = userRealmId !== response?.defaultRealm.id;
        setIsUberRealmChild(res);
      });
    }
  };

  const getMachineById = (machineId: string) => {
    setIsLoading(true);
    getClientById(machineId)
      .then(machine => {
        setMachine(machine);
        !portalV2 && machine?.isUberRealmClient && getDefaultRealm(machine.clientId); //dont remove portalv2 check
        setIsLoading(false);
      })
      .catch(error => {
        displaySnackbar(`${ERROR_MACHINE_NOT_FOUND}: ${error}`, 'error');
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (history.location.state && (history.location.state as any).fromPage === 'add-subscriptions') {
      setValue(3);
    }
    if (history.location.state && (history.location.state as any).fromPage === 'topic-subscriptions') {
      setValue(5);
    }
    if (history.location.state && (history.location.state as any).secretText) {
      setSecretCopyDialog(true);
      updateSecretText((history.location.state as any).secretText);
    }
    getMachineById(machineId);
    setMachineNameLocal(machineName);
    getRealmKeyFromUserToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeTab = (_event: any, newValue: number) => {
    setValue(newValue);
  };
  const getRealmKeyFromUserToken = () => {
    getUserTokenData().then((response: any) => {  
        const realmKey = response.realm_key;
        setRealmKey(realmKey);
    });
  }
  const getCurlNote = () => {
    return (
      <div className={classes.curlNote}>
        <div>{'Replace each placeholder in the command with its corresponding values'}</div>
        <div>{`{REALMKEY}: ${realmKey}`}</div>
        <div>{`{RUNTIME}: ${runtime.customer} | ${runtime.rnd}`}</div>
        <div>{`{GEO}: ${geo}`}</div>
        <div className={classes.domain}>{`{DOMAIN}: ${runtime.customer}`} <ArrowRight/> {`${domain.customer}`} {' (or) '} {`${runtime.rnd}`} <ArrowRight/> {`${domain.rnd}`}</div>
        <div className={classes.example}>{`Eg: https://${realmKey}.auth.interop.na.blueyonder.dev/oauth/token`}</div>
      </div>
    )
  }
  const B2C_EDITOR_TEXT = `curl -X POST 'https://${B2CDomain}/${TenantName}/B2C_1A_ClientCredential/oauth2/v2.0/token?realmId={allowedrealmId}' \\\n-H 'Content-Type: application/x-www-form-urlencoded' \\\n-d 'grant_type=client_credentials' \\\n-d 'client_id=${machine?.clientId}' \\\n-d 'client_secret=<My-generated-client-secret>' \\\n-d 'scope=${scope}'`;
  const GRAVITEE_EDITOR_TEXT = `curl -X POST '${tokenEndpoint}' \\\n-H 'Content-Type: application/x-www-form-urlencoded' \\\n-d 'grant_type=client_credentials' \\\n-d 'client_id=${machine?.clientId}' \\\n-d 'client_secret=<My-generated-client-secret>'`;
  const EDITOR_TEXT = portalV2 ? GRAVITEE_EDITOR_TEXT : B2C_EDITOR_TEXT; //dont remove portalv2 check
  const CURL_NOTE = getCurlNote();

  const getAllowedRealm = () => {
    if (machine?.clientId !== '') {
      getAllowedRealms(machine?.clientId).then((response: any) => {
        const realmList = [response?.defaultRealm];
        if (response?.allowedRealms && response.allowedRealms.length > 0) {
          realmList.push(...response?.allowedRealms);
        }
        setAllowedRealms(realmList);
      });
    }
  };
  useEffect(() => {
    !portalV2 && machine?.isUberRealmClient && getAllowedRealm(); //dont remove portalv2 check
    // editorRefs && editorRefs.setValue(EDITOR_TEXT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [machine?.clientId]);

  const updatePermission =
    assignedPermissions &&
    assignedPermissions.permissions &&
    checkPermission([permissions.machine.read_write], assignedPermissions.permissions);

  const addSecretPermission =
    assignedPermissions &&
    assignedPermissions.permissions &&
    checkPermission([permissions.secret.read_write], assignedPermissions.permissions);

  const addRolePermission =
    assignedPermissions &&
    assignedPermissions.permissions &&
    checkPermission(
      [permissions.role.read, permissions.role.read_write, permissions.role.read_assign],
      assignedPermissions.permissions
    );

  const updateMachineName = (e: { target: { value: string } }) => {
    const prevName = machine.displayName ? machine.displayName.trim() : '';
    const displayName = e.target.value;
    if (displayName !== '' && displayName.trim() !== prevName) {
      dispatch(setCurrentMachineSelection({ ...machine, displayName: e.target.value }));
      showHideLoader(true);
      setSnackbarAlertProps({ ...snackbarAlertProps, show: false });
      updateClient(machine.id, { displayName: displayName })
        .then(() => {
          dispatch(setCurrentMachineName(displayName));
          setSnackbarAlertProps({
            ...snackbarAlertProps,
            show: true,
            message: `Machine name has been updated to ${displayName}`
          });
          showHideLoader(false);
        })
        .catch(error => {
          setSnackbarAlertProps({
            ...snackbarAlertProps,
            show: true,
            message: 'Error in creating machine: ' + error,
            severity: 'error'
          });
          showHideLoader(false);
        });
    }
  };

  const handleMachineNameChange = (e: { target: { value: string } }) => {
    setMachineNameLocal(e.target.value);
  };

  const snackbarSetHidden = () => {
    dispatch(hideSnackbar());
  };

  const displaySnackbar = (message: string, severity: 'success' | 'error') => {
    dispatch(
      setSnackBarMessage({
        autoHideDuration: 5000,
        showSnackbar: true,
        message: message,
        severity: severity
      })
    );
  };

  const handleCopyClick = (type: string) => {
    snackbarSetHidden();
    if (type === 'Subject ID') {
      dispatch(
        setSnackBarMessage({
          ...SNACKBAR_ALERT_DEFAULT_PROPS,
          message: SUBJECT_ID_COPIED_TO_CLIPBOARD,
          severity: 'success'
        })
      );
    } else if (type === 'Client ID') {
      dispatch(
        setSnackBarMessage({
          ...SNACKBAR_ALERT_DEFAULT_PROPS,
          message: CLIENT_ID_COPIED_TO_CLIPBOARD,
          severity: 'success'
        })
      );
    } else {
      dispatch(
        setSnackBarMessage({
          ...SNACKBAR_ALERT_DEFAULT_PROPS,
          message: COMMAND_COPIED_TO_CLIPBOARD,
          severity: 'success'
        })
      );
    }
  };

  const handleRotateClientSecret = (machineId: string) => {
    setDialogHideLoader(true);
    rotateClientSecret(machineId)
      .then((response: any) => {
        displaySnackbar(ROTATE_CLIENT_SECRET_SUCCESS, 'success');
        setDialogHideLoader(false);
        setShowSecretConfirmation(false);
        updateSecretText(response.secretText);
        setSecretCopyDialog(true);
      })
      .catch((error: any) => {
        setDialogHideLoader(false);
        setShowSecretConfirmation(false);
        displaySnackbar(interpolateString([error.message], ROTATE_CLIENT_SECRET_FAILURE), 'error');
      });
  };

  const handleClose = () => {
    setSecretCopyDialog(!secretCopyDialog);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }
  const getMachineSubtitle = () => {
    let subtitle = '';
    if (machine?.type) {
      subtitle = `Type: ${MACHINE_TYPES[machine.type] || ''}`;
    }
    if (
      machine?.isExternal !== undefined &&
      portalV2 &&
      selectedRealmInfo.envType === 'admin' &&
      machine?.type === 'apim'
    ) {
      subtitle += machine?.isExternal === false ? ` | Category: ${LABELS.INTERNAL}` : ` | Category: ${LABELS.EXTERNAL}`;
    }
    return subtitle;
  };
  const keyInformationSlot = [
    <Tooltip arrow placement="bottom" title={UBER_REALM_CLIENT_TOOLTIP}>
      <Box className={classes.uberTag}>
        <LuiObjectTag title={UBER} colorVariant="white" />
      </Box>
    </Tooltip>
  ];

  const columns: any = [
    {
      id: 'name',
      Header: 'Realm Name',
      accessorKey: 'name',
      muiTableHeadCellProps: {
        sx: {
          width: 'auto'
        }
      }
    },
    {
      id: 'id',
      Header: 'Realm Id',
      accessorKey: 'id',
      muiTableHeadCellProps: {
        sx: {
          width: 'auto'
        }
      }
    }
  ];
  return (
    <>
      <Box className={classes.root}>
        <LuiPageHeader
          title={
            machine?.displayName || (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Skeleton variant="text" animation={'pulse'} width={150} />
                <Skeleton variant="text" animation={'pulse'} width={300} />
              </Box>
            )
          }
          subtitle={getMachineSubtitle()}
          isCollapsable={false}
          keyInformationSlot={machine?.isUberRealmClient ? keyInformationSlot : undefined}
          onClickBack={() => {
            if (history.location.search) {
              history.push(`/${history.location.search}`);
            } else {
              history.goBack();
            }
            dispatch(setSelectedTab('Machines'));
          }}
        ></LuiPageHeader>
        <Box className={classes.tabBoxMain}>
          <LuiCard elevation={1} hasCardContentPadding={false} className={classes.card}>
            <Box sx={{ flexGrow: 1, display: 'flex', height: height - 108 }}>
              {isLoading && (
                <Tabs
                  value={value}
                  variant="standard"
                  orientation="vertical"
                  className={classes.tabs}
                  onChange={handleChangeTab}
                  aria-label="Vertical tabs"
                  data-testid="vertical-tabs"
                  TabIndicatorProps={{
                    style: {
                      left: '5px',
                      width: '4px',
                      height: '32px',
                      marginTop: '8px'
                    }
                  }}
                >
                  <Tab label={<Skeleton variant="text" animation={'pulse'} width={85} />} />
                  <Tab label={<Skeleton variant="text" animation={'pulse'} width={85} />} />
                  <Tab label={<Skeleton variant="text" animation={'pulse'} width={85} />} />
                </Tabs>
              )}
              {!isLoading && (
                <Tabs
                  value={value}
                  orientation="vertical"
                  centered={false}
                  className={classes.tabs}
                  onChange={handleChangeTab}
                  aria-label="Vertical tabs"
                  data-testid="vertical-tabs"
                  TabIndicatorProps={{
                    sx: { left: 0 }
                  }}
                >
                  <Tab value={0} className={classes.tabTextStyle} label={LABELS.GENERAL} {...a11yProps(0)} />
                  {showClassicSecretsTab && (
                    <Tab
                      value={1}
                      className={classes.tabTextStyle}
                      label={`${LABELS.SECRETS} ${
                        selectedRealmInfo?.migrationState !== MIGRATION_STATUS.CLASSIC
                          ? `(${secretTypeOptions.CLASSIC})`
                          : ''
                      }`}
                      {...a11yProps(1)}
                    />
                  )}
                  {showModernSecretsTab && (
                    <Tab
                      value={6}
                      className={classes.tabTextStyle}
                      label={`${LABELS.SECRETS} ${
                        selectedRealmInfo?.migrationState !== MIGRATION_STATUS.MODERN
                          ? `(${secretTypeOptions.MODERN})`
                          : ''
                      }`}
                      {...a11yProps(1)}
                    />
                  )}
                  {machine?.type === 'apim' && (
                    <Tab value={2} className={classes.tabTextStyle} label={LABELS.ROLES} {...a11yProps(2)} />
                  )}
                  {portalV2 && machine?.type === 'apim' && (
                    <Tab value={3} className={classes.tabTextStyle} label={LABELS.API} {...a11yProps(3)} />
                  )}
                  {!portalV2 && machine?.isUberRealmClient && (
                    <Tab value={4} className={classes.tabTextStyle} label={LABELS.REALMS} {...a11yProps(4)} />
                  )}
                  {efsFFEnabled && selectedRealmInfo?.envType !== 'admin' && machine?.type === 'EFS' && (
                    <Tab value={5} className={classes.tabTextStyle} label={LABELS.TOPICS} {...a11yProps(5)} />
                  )}
                </Tabs>
              )}

              <TabPanel className={classes.tabWrapperCard} value={value} index={0}>
                <Box className={classes.machineNameInputContent}>
                  <TextField
                    fullWidth
                    id="machineName"
                    value={machineNameLocal}
                    name={MACHINE_NAME}
                    label={MACHINE_NAME_LABEL}
                    onBlur={updateMachineName}
                    placeholder="Enter Machine Name"
                    onChange={e => handleMachineNameChange(e)}
                    className={classes.machineInput}
                    variant="standard"
                    disabled={!updatePermission}
                    InputProps={{
                      readOnly: isUberRealmChild && machine.isUberRealmClient
                    }}
                  />
                  {showLoader ? (
                    <Box className={classes.loader}>
                      <CircularProgress color="primary" size={25} thickness={4} aria-label="circular-progress" />{' '}
                    </Box>
                  ) : (
                    <Box className={classes.loader}></Box>
                  )}
                </Box>
                <Box className={classes.contentContainer}>
                  <Typography gutterBottom variant="body1" fontWeight={500}>
                    {' '}
                    {MACHINE_TYPE}
                  </Typography>
                  <Box className={classes.valueContainer}>
                    <Typography gutterBottom variant="body1" className={classes.content}>
                      {MACHINE_TYPES[machine?.type] || machine?.type}
                    </Typography>
                  </Box>
                </Box>
                {portalV2 && selectedRealmInfo?.type === REALM_TYPE.APPLICATION && machine?.type === 'apim' ? (
                  <Box className={classes.contentContainer}>
                    <Typography gutterBottom variant="body1" fontWeight={500}>
                      {MACHINE_CATEGORY_TYPE}
                    </Typography>
                    <Box className={classes.valueContainer}>
                      <Typography gutterBottom variant="body1" className={classes.content}>
                        {machine?.isExternal === false ? LABELS.INTERNAL : LABELS.EXTERNAL}
                      </Typography>
                    </Box>
                  </Box>
                ) : null}
                <Box className={classes.contentContainer}>
                  <DisplayContent
                    contentText={CLIENT_ID}
                    content={machine?.clientId || ''}
                    testId={COPY_IDS.clientId}
                    isNewUser={false}
                    handleCopyClick={() => handleCopyClick(CLIENT_ID)}
                  />
                </Box>
                <Box className={classes.contentContainer}>
                  <DisplayContent
                    contentText={SUBJECT_ID}
                    content={machine?.subjectId || ''}
                    testId={COPY_IDS.subjectId}
                    isNewUser={false}
                    handleCopyClick={() => handleCopyClick(SUBJECT_ID)}
                  />
                </Box>
              </TabPanel>
              <TabPanel className={classes.tabWrapperCard} value={value} index={1}>
                <Box>
                  {(!classicSecrets || classicSecrets.length > 0 || !isUberRealmChild) && (
                    <Box>
                      <Typography data-testid="client-secret-title" gutterBottom variant="body1" fontWeight={500}>
                        {`${CLIENT_SECRET_TITLE} ${
                          selectedRealmInfo?.migrationState !== MIGRATION_STATUS.CLASSIC
                            ? `(${secretTypeOptions.CLASSIC})`
                            : ''
                        }`}
                      </Typography>
                      <Typography
                        gutterBottom
                        data-testid="client-secret-subtitle"
                        variant="body1"
                        className={classes.heading}
                      >
                        {CLIENT_SECRET_SUBTITLE}
                      </Typography>
                      <Box display="flex" alignItems="center">
                        <div className={classes.elevate}>
                          {classicSecrets &&
                            classicSecrets.map((secretItem: ISecret, index: number) => (
                              <SecretDetails
                                key={index}
                                hint={secretItem.hint}
                                expiry={secretItem.expiry}
                                machineId={machine?.id}
                                keyId={secretItem.id ? secretItem.id : ''}
                                refreshOnSave={() => getMachineById(machineId)}
                                displaySnackbar={displaySnackbar}
                                hideSnackbar={snackbarSetHidden}
                                hideDeleteButton={machine.isUberRealmChild || (portalV2 && classicSecrets.length <= 1)}
                                hideRotateButton={true}
                                rotateClientSecret={() => {}}
                              />
                            ))}
                          {addSecretPermission &&
                            !isUberRealmChild &&
                            (!classicSecrets || classicSecrets.length < allowedSecretCount) && (
                              <AddSecretBox
                                machineId={machine?.id}
                                hideSnackbar={snackbarSetHidden}
                                displaySnackbar={displaySnackbar}
                                maxExpiryDays={machine?.maxExpiryDays}
                                refreshOnSave={() => getMachineById(machineId)}
                                machineType={machine?.type}
                                isModern={false}
                              />
                            )}
                        </div>
                      </Box>
                    </Box>
                  )}
                </Box>
                {machine?.type !== (MACHINE_TYPE_SNOWFLAKE_CAPITAL || MACHINE_TYPE_SNOWFLAKE_LOWER) ? (
                  <Box>
                    <Typography variant="body1" className={classes.heading}>
                      {machine?.type !== 'EFS' ? EDITOR : EDITOR_TOPICS}
                    </Typography>
                    <Box className={classes.editorContainer}>
                      <Box className={classes.copyButton}>
                        <Tooltip title="copy">
                          <Box data-testid="toolTip-sign">
                            <CopyToClipboard
                              data-testid={`display-copy-to-clipboard-${COPY_IDS.tokenRequest}`}
                              text={EDITOR_TEXT}
                              onCopy={handleCopyClick}
                            >
                              <Copy id="display-content-id" fontSize="small" />
                            </CopyToClipboard>
                          </Box>
                        </Tooltip>
                      </Box>
                      <Box className={classes.editor}>
                        <LuiEditor
                          height={140}
                          fontSize={14}
                          readOnly={true}
                          fontFamily="Monospace"
                          defaultValue={EDITOR_TEXT}
                          defaultLanguage={'CustomLang'}
                        />
                      </Box>
                    </Box>
                  </Box>
                ) : null}
              </TabPanel>
              <TabPanel className={classes.tabWrapperCard} value={value} index={6}>
                <Box>
                  {(!modernSecrets || modernSecrets.length > 0 || !isUberRealmChild) && (
                    <Box>
                      <Typography data-testid="client-secret-title" gutterBottom variant="body1" fontWeight={500}>
                        {`${CLIENT_SECRET_TITLE} ${
                          selectedRealmInfo?.migrationState !== MIGRATION_STATUS.MODERN
                            ? `(${secretTypeOptions.MODERN})`
                            : ''
                        }`}
                      </Typography>
                      <Typography
                        gutterBottom
                        data-testid="client-secret-subtitle"
                        variant="body1"
                        className={classes.heading}
                      >
                        {CLIENT_SECRET_SUBTITLE}
                      </Typography>
                      <Box display="flex" alignItems="center">
                        <div className={classes.elevate}>
                          {machine &&
                            modernSecrets &&
                            modernSecrets.map((secretItem: ISecret, index: number) => {
                              if (secretItem.type === MIGRATION_STATUS.MODERN) {
                                return (
                                  <SecretDetails
                                    key={index}
                                    hint={secretItem.hint}
                                    expiry={secretItem.expiry}
                                    machineId={machine?.id}
                                    keyId={secretItem.id ? secretItem.id : ''}
                                    refreshOnSave={() => getMachineById(machineId)}
                                    displaySnackbar={displaySnackbar}
                                    hideSnackbar={snackbarSetHidden}
                                    hideDeleteButton={
                                      machine.isUberRealmChild || (portalV2 && machine.secrets.length <= 1)
                                    }
                                    hideRotateButton={true}
                                    rotateClientSecret={() => {}}
                                  />
                                );
                              }
                            })}
                          {addSecretPermission &&
                            !isUberRealmChild &&
                            (!modernSecrets || modernSecrets.length < allowedSecretCount) && (
                              <AddSecretBox
                                machineId={machine?.id}
                                hideSnackbar={snackbarSetHidden}
                                displaySnackbar={displaySnackbar}
                                maxExpiryDays={machine?.maxExpiryDays}
                                refreshOnSave={() => getMachineById(machineId)}
                                machineType={machine?.type}
                                isModern={true}         
                              />
                            )}
                        </div>
                      </Box>
                    </Box>
                  )}
                </Box>
                {machine?.type !== (MACHINE_TYPE_SNOWFLAKE_CAPITAL || MACHINE_TYPE_SNOWFLAKE_LOWER) ? (
                  <Box>
                    <Typography variant="body1" className={classes.heading}>
                      {machine?.type !== 'EFS' ? EDITOR : EDITOR_TOPICS}
                    </Typography>
                    <Box className={classes.editorContainer}>
                      <Box className={classes.copyButton}>
                        <Tooltip title="copy">
                          <Box data-testid="toolTip-sign">
                            <CopyToClipboard
                              data-testid={`display-copy-to-clipboard-${COPY_IDS.tokenRequest}`}
                              text={GRAVITEE_EDITOR_TEXT}
                              onCopy={handleCopyClick}
                            >
                              <Copy id="display-content-id" fontSize="small" />
                            </CopyToClipboard>
                          </Box>
                        </Tooltip>
                      </Box>
                      <Box className={classes.editor}>
                        <LuiEditor
                          height={140}
                          fontSize={14}
                          readOnly={true}
                          fontFamily="Monospace"
                          defaultValue={GRAVITEE_EDITOR_TEXT}
                          defaultLanguage={'CustomLang'}
                        />
                      </Box>
                    </Box>
                    <Box>
                      {!portalV2 && (
                        <Alert  elevation={0} severity={'info'} variant='outlined'>
                          {CURL_NOTE}
                        </Alert>
                      )}
                      </Box>
                  </Box>
                ) : null}
              </TabPanel>
              <TabPanel className={classes.tabWrapperCard} value={value} index={2}>
                <Box className={classes.rolesContainer}>
                  {addRolePermission && machine?.subjectId && machine.displayName && (
                    <RoleAssignments
                      id={machine?.id}
                      name={machine.displayName}
                      subjectId={machine?.subjectId}
                      autoCompleteTextPlaceholder={AUTOCOMPLETE_PLACEHOLDER}
                    />
                  )}
                </Box>
              </TabPanel>
              {portalV2 && machine?.type !== 'EFS' && (
                <TabPanel className={classes.tabWrapperCard} value={value} index={3}>
                  <ApiSubscriptions machineId={machine?.id} />
                </TabPanel>
              )}
              {!portalV2 && machine?.isUberRealmClient && (
                <TabPanel className={classes.tabWrapperCard} value={value} index={4}>
                  {machine?.type !== (MACHINE_TYPE_SNOWFLAKE_CAPITAL || MACHINE_TYPE_SNOWFLAKE_LOWER) ? (
                    <LuiMaterialTable
                      paging
                      initialState={{ pagination: { pageSize: 25, pageIndex: 0 } }}
                      paginationProps={{
                        rowsPerPageOptions: [10, 25, 50]
                      }}
                      keyAccessor={'id'}
                      columns={columns}
                      data={allowedRealms}
                      isHeaderSticky={true}
                      columnResizable={false}
                      maxTableBodyHeight={height - 250}
                      enableColumnActions={false}
                      enableAlternateRowStyle={true}
                      loading={allowedRealms.length === 0}
                    />
                  ) : null}
                </TabPanel>
              )}
              {selectedRealmInfo?.envType !== 'admin' && machine?.type === 'EFS' && (
                <TabPanel value={value} index={5}>
                  <TopicSubscription machineId={machine?.id} machine={machine} />
                </TabPanel>
              )}
            </Box>
          </LuiCard>
        </Box>
      </Box>

      {portalV2 && secretCopyDialog && (
        <FormDialog
          openModal={secretCopyDialog}
          dialogTitle={CLIENT_SECRET_TITLE}
          handleClose={handleClose}
          dialogAction1={
            <Button
              variant={'contained'}
              name={'closeBtn'}
              color="primary"
              disableElevation
              disabled={showLoader}
              onClick={handleClose}
            >
              {BUTTON_CLOSE}
            </Button>
          }
          dialogAction2={<></>}
        >
          <MachineSecretCopyDialog secretText={secretText} displaySnackbar={displaySnackbar}></MachineSecretCopyDialog>
        </FormDialog>
      )}
      <SnackbarAlert />
      {showSecretConfirmation && (
        <AlertDialog
          dialogTitle={ROTATE_SECRET_TITLE}
          dialogContentText={ROTATE_SECRET_CONTENT}
          recordName={machineName}
          primaryButtonText={ROTATE_SECRET}
          secondButtonText={DIALOGUE_CANCEL}
          handleOnCancel={() => setShowSecretConfirmation(false)}
          handleOnOk={() => handleRotateClientSecret(machineId)}
          showDialogLoader={showDialogLoader}
        />
      )}
    </>
  );
};

export default MachineDetails;
